// Korte uitleg per module — getoond in een info-modal naast de naam.
// Lang genoeg om de waarde te begrijpen, kort genoeg om snel te scannen.
// Gedeeld tussen de onboarding-flow (Step4Modules) en de
// Abonnement-instellingenpagina (Subscription.jsx).

const MODULE_DESCRIPTIONS = {
    impactMeten: {
        tagline: 'Bouw je Theory of Change en meet effecten.',
        body: 'Met Impact meten ontwerp je een Theory of Change (impactdoel → effecten → activiteiten → outputs), kies je effecten uit de MSI-standaard of maak je eigen, en zet je vragenlijsten uit naar deelnemers. De verzamelde data wordt automatisch opgeschaald in dashboards en rapportages.',
        bestFor: 'Organisaties die structureel hun maatschappelijke effect willen onderbouwen — voor financiers, eigen sturing of certificering.',
    },
    personas: {
        tagline: 'Volg deelnemers door de tijd op individu-niveau.',
        body: 'Personas slaat per deelnemer profielinformatie, voortgang, doelen en intakeformulieren op. Combineer met Impact meten om effecten per persoon te volgen, of gebruik standalone als deelnemerregistratie.',
        bestFor: 'Organisaties met intensief deelnemer-contact — re-integratie, jeugdwerk, schuldhulp, training, coaching.',
    },
    housevisits: {
        tagline: 'FIXtool voor wijkgerichte huisbezoeken.',
        body: 'Gestructureerde huisbezoeken plannen, uitvoeren en opvolgen. Inclusief intakeformulieren, taken per huishouden en koppeling met materiaalvoorraad. Standaard gebruikt door FIXbrigades voor energiearmoede-aanpak.',
        bestFor: 'Wijkgerichte programma\'s — energiearmoede, woonlasten, sociaal werk, mantelzorgondersteuning.',
    },
    portfolio: {
        tagline: 'Stuur meerdere projecten of organisaties aan.',
        body: 'Portfolio geeft je een meta-omgeving met sub-projecten of leden-organisaties. Per project zie je benchmarks, voortgang en onderling vergelijk. Geschikt voor fondsen, koepels en samenwerkingsverbanden.',
        bestFor: 'Fondsen, koepelorganisaties, multi-projectprogramma\'s.',
    },
}

export default MODULE_DESCRIPTIONS
